(function () {
    'use strict';

    class ScheduledSessionsController extends Controllers.BaseControllerES6 {


        // @ngInject
        constructor($scope, $injector, AppStates, $state, moment) {
            super($scope, $injector);
            this.__objectType = 'ScheduledSessionsController';

            this.moment = moment;

            this.AppStates = AppStates;
            this.$state = $state;
        }

        $onInit() {
            this.MAX_DISPLAY = 2;
            this.sessionsDisplayLimit = this.MAX_DISPLAY;
        }

        shouldShowExpand() {
            return this.sessions && this.sessions.length > this.MAX_DISPLAY && this.sessionsDisplayLimit === this.MAX_DISPLAY;
        }

        expand() {
            this.sessionsDisplayLimit = undefined; // causing ng-repeat limitTo to be ignored
        }

        getSortedSessions() {
            if (!this.sessions) {
                return [];
            }

            return this.sessions.sort((a, b) => {
                return new Date(this.getSessionDate((a))) - new Date(this.getSessionDate(b));
            });
        }

        getSessionDate(session) {
            return session.date_start || session.date_time_start;
        }
    }

    Components.ScheduledSessions = {
        bindings: {
            sessions: '<'
        },
        controller: ScheduledSessionsController,
        name: 'hbScheduledSessions',
        templateUrl: 'angular/app/modules/core/features/workspace/scheduled_sessions/scheduled_sessions_component_template.html',
    };

}());